"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var SimpleExamplePaper_1 = require("./SimpleExamplePaper");
var PropertiesPaper_1 = require("./PropertiesPaper");
exports.ComponentPaperPage = function () { return (React.createElement(common_1.Page, { headerText: "Paper" },
    React.createElement(common_1.Paragraph, null, "Paper is used to give elevation sensation. To do that, it uses box shadow."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(SimpleExamplePaper_1.SimpleExamplePaper, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesPaper_1.PropertiesPaper, null))); };
exports.ComponentPaperPage.displayName = 'ComponentPaperPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentPaperPage/ComponentPaperPage.tsx
// module id = 694
// module chunks = 0